/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {TSRole} from '../../../models/enums/TSRole';
import {TSVorleistungArt, vorleistungArtPrefix} from '../../../models/enums/TSVorleistungArt';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSVorleistung from '../../../models/TSVorleistung';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IScope = angular.IScope;
import ITimeoutService = angular.ITimeoutService;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-vorleistungen-list.html');
require('./dv-vorleistungen-list.scss');

export class DVVorleistungenListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        vorleistungen: '=',
        schadenfall: '<',
        onEdit: '&',
        onDelete: '&',
        readonly: '<',
        schaetzung: '<',
    };
    template = template;
    controller = DVVorleistungenListController;
    controllerAs = 'vm';
}

export class DVVorleistungenListController {

    itemsByPage: number;
    colnumber: number | undefined = undefined;
    vorleistungen: Array<TSVorleistung> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    onDelete: (paramObj: any) => void;
    readonly: boolean;
    schadenfall: TSSchadenfall;
    schaetzung: boolean;

    static $inject: any[] = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate'
        , '$timeout', 'SchadenfallModelManager',
    ];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService,
                private $timeout: ITimeoutService, private schadenfallModelManager: SchadenfallModelManager,
    ) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {
        this.$timeout(() => {
            this.initColNumber();
        });
        this.calculateBerechtigterBetragForOldCases();
    }

    private calculateBerechtigterBetragForOldCases() {
        // the following calculation is for handling old cases, where Berechtigter Betrag belongs to each Vorleistung, not to the Schadenfall
        if (this.schadenfall.berechtigterBetragVorleistungen === null || this.schadenfall.berechtigterBetragVorleistungen === 0) {

            this.schadenfall.berechtigterBetragVorleistungen = this.vorleistungen.reduce(
                (accumulator: number, currentValue: TSVorleistung) => accumulator + currentValue.vorleistungDatenFS.berechtigterBetrag, 0);
        }
    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();

    }

    editClicked(vorleistungToEdit: any, event: any) {
        this.onEdit({vorleistung: vorleistungToEdit, event: event});
    }

    deleteClicked(vorleistungToDelete: any, event: any) {
        this.onDelete({vorleistung: vorleistungToDelete, event: event});
    }

    translateVorleistungArt(vorleistungArt: TSVorleistungArt): string {
        let prefix = vorleistungArtPrefix();
        return this.$translate.instant(prefix + TSVorleistungArt[vorleistungArt])
    }

    public getColumnsNumber(): number {
        if (this.colnumber === undefined) {
            this.initColNumber();

        }
        return this.colnumber!;
    }

    private initColNumber() {
        let element = angular.element('.dv-vorleistungen-list .header-row').first();
        if (element) {
            this.colnumber = element.get(0).childElementCount;
        } else {
            //could not determine actual number, just returing an approximation
            this.colnumber = 5;
        }
    }

    public calcTotalBetrag(): number {
        let total = 0;
        if (this.vorleistungen !== undefined) {
            for (let obj of this.vorleistungen) {
                if (obj && obj.vorleistungDatenFS && obj.vorleistungDatenFS.betrag) {
                    total += obj.vorleistungDatenFS.betrag;
                }
            }
        }
        return total;
    }

    private speichernGesuch(): void {
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchadenfall(this.schadenfall);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-vorleistungen-list/dv-vorleistungen-list.ts